import { useState } from "react";
import { Link } from "react-router-dom";

const services = [
  {
    id: "residential",
    title: "Residential Window Cleaning",
    tagline: "Sparkling windows for your home",
    icon: "ri-home-4-fill",
    color: "#1E88E5",
    bgLight: "#EBF4FF",
    image: "https://public.readdy.ai/ai/img_res/09f37a012e0b612e058a3af128bac885.jpg",
    desc: "We provide thorough, reliable window cleaning for all types of residential properties across Northfleet and Gravesend. Whether you have a flat, terraced house, semi, or detached home, our team will leave your windows sparkling.",
    benefits: [
      "Interior and exterior window cleaning",
      "Frame and sill wiping included",
      "Water-fed pole purified water system",
      "Streak-free finish guaranteed",
      "Safe access to all window heights",
      "Regular scheduled visits available",
    ],
    maintenanceOptions: null,
  },
  {
    id: "commercial",
    title: "Commercial Window Cleaning",
    tagline: "A professional image for your business",
    icon: "ri-building-4-fill",
    color: "#0369A1",
    bgLight: "#E0F2FE",
    image: "https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20exterior%20with%20perfectly%20clean%20sparkling%20glass%20facade%2C%20crystal%20clear%20floor%20to%20ceiling%20windows%20reflecting%20blue%20sky%20and%20clouds%20without%20a%20single%20streak%2C%20wide%20angle%20low%20perspective%20architectural%20photography%2C%20UK%20city%20business%20district%2C%20bright%20midday%20sunlight%2C%20ultra%20sharp%20photorealistic%20professional%20photography%2C%20no%20people%20visible&width=800&height=500&seq=svc-com-v4&orientation=landscape",
    desc: "First impressions matter. We keep your business premises spotless with reliable commercial window cleaning services tailored to your schedule. We serve offices, retail units, restaurants, schools, and more.",
    benefits: [
      "Flexible scheduling around your business hours",
      "Health & safety compliant methods",
      "Regular contract cleaning available",
      "All commercial property types covered",
      "Insured and uniformed professionals",
      "Minimal disruption to your operations",
    ],
    maintenanceOptions: null,
  },
  {
    id: "conservatory",
    title: "Conservatory & Glass Cleaning",
    tagline: "Restore light and clarity to every pane",
    icon: "ri-sun-cloudy-fill",
    color: "#0F766E",
    bgLight: "#CCFBF1",
    image: "https://readdy.ai/api/search-image?query=gleaming%20spotless%20white%20uPVC%20conservatory%20attached%20to%20a%20beautiful%20UK%20home%2C%20crystal%20clear%20polycarbonate%20and%20glass%20roof%20panels%20absolutely%20sparkling%20in%20afternoon%20sunshine%2C%20bright%20interior%20filled%20with%20natural%20light%2C%20lush%20garden%20surroundings%2C%20wide%20angle%20exterior%20architectural%20photography%2C%20ultra%20sharp%20photorealistic%2C%20no%20people%2C%20immaculate%20result%2C%20professional%20photography&width=800&height=500&seq=svc-cons-v4&orientation=landscape",
    desc: "Our specialist conservatory and glass cleaning service removes algae, mould, dirt, and limescale from roofs, panels, and all glass surfaces — restoring your conservatory to its best and letting the light flood back in.",
    benefits: [
      "Full conservatory roof cleaning",
      "Inside and outside glass panels",
      "Algae and green staining removal",
      "uPVC frame and door cleaning",
      "Skylight and lantern roof cleaning",
      "Biodegradable cleaning solutions",
    ],
    maintenanceOptions: null,
  },
  {
    id: "maintenance",
    title: "Regular Maintenance Cleaning",
    tagline: "Keep your windows looking their best year-round",
    icon: "ri-calendar-check-fill",
    color: "#7C3AED",
    bgLight: "#EDE9FE",
    image: "https://public.readdy.ai/ai/img_res/edited_52d0e6bc5c6f5af583c014ffe307d78a_9f4d2c78.jpg",
    desc: "Our regular maintenance plans are the most popular choice for our customers. Set up a recurring schedule —from 6-12 weekly  or quarterly — and we'll keep your property consistently clean without you having to think about it.",
    benefits: [
      "Monthly, bi-monthly, or quarterly options",
      "Priority booking for existing customers",
      "Consistent team assigned to your property",
      "Automatic reminders and easy rescheduling",
      "Discounted rates for long-term contracts",
      "No lock-in contracts — cancel anytime",
    ],
    maintenanceOptions: null,
  },
  {
    id: "residential-gutter",
    title: "Residential Gutter Clearance",
    tagline: "Protect your home from costly water damage",
    icon: "ri-home-gear-fill",
    color: "#B45309",
    bgLight: "#FEF3C7",
    image: "https://readdy.ai/api/search-image?query=close%20up%20view%20of%20clean%20clear%20gutters%20on%20a%20neat%20UK%20residential%20home%2C%20perfectly%20cleared%20gutters%20with%20no%20leaves%20or%20debris%2C%20fresh%20clean%20fascia%20boards%2C%20professional%20result%20after%20gutter%20clearance%20service%2C%20wide%20angle%20roofline%20shot%2C%20bright%20daylight%2C%20photorealistic%20ultra%20sharp%20crystal%20clear%2C%20no%20people%2C%20professional%20architectural%20photography%2C%20immaculate%20clean%20result&width=800&height=500&seq=svc-gutres-v4&orientation=landscape",
    desc: "Blocked gutters are one of the most common causes of damp, fascia damage, and structural issues in UK homes. Our professional residential gutter clearance service in Northfleet and Gravesend removes leaves, moss, and debris quickly and safely — keeping your home protected from water damage all year round. Using the latest high-powered vacuum, we clear and inspect your gutters without the need for ladders in many cases, making the process safer and more efficient.",
    benefits: [
      "Full gutter vacuum clearance",
      "Fascia and soffit inspection included",
      "Moss and leaf debris removal",
      "Covers all guttering types & profiles",
    ],
    maintenanceOptions: {
      oneOff: {
        label: "One-Off Gutter Clearance",
        desc: "Perfect for homeowners who need a one-time deep clear of blocked or overflowing gutters. Ideal before winter or after heavy storms. Our team will remove all debris and confirm everything is flowing freely.",
      },
      regular: {
        label: "Regular Gutter Maintenance Plan",
        desc: "Our most popular option for homeowners in Northfleet and Gravesend. Choose from twice-yearly, annual, or seasonal visits. Regular gutter maintenance prevents costly repairs, keeps your home protected year-round, and qualifies you for priority scheduling and reduced rates.",
      },
    },
  },
  {
    id: "commercial-gutter",
    title: "Commercial Gutter Clearance",
    tagline: "Keep your commercial property compliant and protected",
    icon: "ri-building-2-fill",
    color: "#065F46",
    bgLight: "#D1FAE5",
    image: "https://readdy.ai/api/search-image?query=large%20modern%20commercial%20warehouse%20or%20retail%20building%20exterior%20with%20clean%20clear%20industrial%20guttering%20and%20drainage%20systems%2C%20wide%20angle%20exterior%20architectural%20shot%2C%20UK%20business%20estate%2C%20bright%20overcast%20daylight%2C%20clean%20maintained%20roofline%2C%20photorealistic%20ultra%20sharp%20professional%20photography%2C%20no%20people%20visible%2C%20immaculate%20building%20exterior%2C%20crisp%20high%20definition&width=800&height=500&seq=svc-gutcom-v4&orientation=landscape",
    desc: "Blocked or overflowing gutters on commercial properties can lead to serious structural damage, flooding, and even health & safety liabilities. Mighty Cleaning Services Ltd provides professional commercial gutter clearance across Northfleet, Gravesend, and the Kent area — keeping your business premises safe, compliant, and protected. We service offices, warehouses, retail units, schools, and industrial estates with minimal disruption to your operations.",
    benefits: [
      "Industrial-grade vacuum clearance system",
      "RAMS documentation available on request",
      "All commercial property types covered",
      "Flexible scheduling to minimise disruption",
    ],
    maintenanceOptions: {
      oneOff: {
        label: "One-Off Commercial Gutter Clearance",
        desc: "Need a fast, professional clear of blocked commercial gutters? Our one-off service is available across Northfleet, Gravesend, and Kent. We'll assess, clear, and test your guttering system — ideal for reactive maintenance or pre-inspection visits.",
      },
      regular: {
        label: "Commercial Gutter Maintenance Contract",
        desc: "Protect your commercial property investment with a scheduled maintenance contract. We offer quarterly, bi-annual, and annual gutter clearance plans for businesses across Gravesend and the surrounding areas. Planned maintenance reduces the risk of expensive emergency repairs, keeps your drains flowing, and ensures compliance with your property management obligations.",
      },
    },
  },
];

export default function ServicesList() {
  const [activeTab, setActiveTab] = useState<Record<string, "oneOff" | "regular">>({});

  const getTab = (id: string) => activeTab[id] ?? "oneOff";

  const setTab = (id: string, tab: "oneOff" | "regular") => {
    setActiveTab((prev) => ({ ...prev, [id]: tab }));
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="space-y-20">
          {services.map((service, index) => (
            <article
              key={service.id}
              id={service.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-start ${
                index % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              {/* Image */}
              <div className="w-full h-80 rounded-2xl overflow-hidden lg:[direction:ltr]">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="lg:[direction:ltr]">
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-xl"
                    style={{ backgroundColor: service.bgLight }}
                  >
                    <i className={`${service.icon} text-xl`} style={{ color: service.color }}></i>
                  </div>
                  <span
                    className="font-heading font-semibold text-sm uppercase tracking-widest"
                    style={{ color: service.color }}
                  >
                    {service.tagline}
                  </span>
                </div>
                <h2
                  className="font-heading text-[#0F2040] leading-tight mb-4"
                  style={{ fontSize: "clamp(1.5rem, 2.5vw, 2rem)", fontWeight: 800 }}
                >
                  {service.title}
                </h2>
                <p className="text-gray-600 font-body text-base leading-relaxed mb-7">
                  {service.desc}
                </p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-7">
                  {service.benefits.map((benefit) => (
                    <li key={benefit} className="flex items-start gap-2.5">
                      <i
                        className="ri-check-line text-sm mt-0.5 flex-shrink-0"
                        style={{ color: service.color }}
                      ></i>
                      <span className="font-body text-sm text-gray-600">{benefit}</span>
                    </li>
                  ))}
                </ul>

                {/* One-Off / Regular Tabs for gutter services */}
                {service.maintenanceOptions && (
                  <div className="mb-7">
                    <div className="flex items-center gap-1 bg-gray-100 rounded-full px-1 py-1 w-fit mb-4">
                      <button
                        onClick={() => setTab(service.id, "oneOff")}
                        className={`px-4 py-1.5 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                          getTab(service.id) === "oneOff"
                            ? "bg-white text-[#0F2040] shadow-sm"
                            : "text-gray-500 hover:text-gray-700"
                        }`}
                      >
                        One-Off
                      </button>
                      <button
                        onClick={() => setTab(service.id, "regular")}
                        className={`px-4 py-1.5 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                          getTab(service.id) === "regular"
                            ? "bg-white text-[#0F2040] shadow-sm"
                            : "text-gray-500 hover:text-gray-700"
                        }`}
                      >
                        Regular Maintenance
                      </button>
                    </div>
                    <div
                      className="rounded-xl p-4 border-l-4"
                      style={{ backgroundColor: service.bgLight, borderColor: service.color }}
                    >
                      <p className="font-heading font-semibold text-sm text-[#0F2040] mb-1.5">
                        {getTab(service.id) === "oneOff"
                          ? service.maintenanceOptions.oneOff.label
                          : service.maintenanceOptions.regular.label}
                      </p>
                      <p className="font-body text-sm text-gray-600 leading-relaxed">
                        {getTab(service.id) === "oneOff"
                          ? service.maintenanceOptions.oneOff.desc
                          : service.maintenanceOptions.regular.desc}
                      </p>
                    </div>
                  </div>
                )}

                <div className="flex flex-wrap gap-4">
                  <a
                    href="#quote-form"
                    className="flex items-center gap-2 text-white font-heading font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                    style={{ backgroundColor: service.color }}
                  >
                    <i className="ri-file-list-3-line"></i>
                    Get a Free Quote
                  </a>
                  <a
                    href="tel:02084322244"
                    className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-[#1A3A6B] font-heading font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-phone-fill"></i>
                    Call Now
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
